// extracted by mini-css-extract-plugin
module.exports = {"slyn8ky":"slyn8ky","pv1k4t7":"pv1k4t7","sq4k8cp":"sq4k8cp","s1um8jkh":"s1um8jkh","speakerWiggle-s1um8jkhpv1k4t7":"speakerWiggle-s1um8jkhpv1k4t7","w1azqaf0":"w1azqaf0"};